import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import {LoadingCircle} from '../../../../src/components/common/loading';
import { NavigationList, NavigationListItem } from '@dbk/ui-list';
import { Label } from '@dbk/ui-forms';
import { NotificationWarning } from '@dbk/ui-icons';
import { Text } from 'react-native';
import { ROUTES, MANAGE_CONTACT_DETAILS_CONSTANTS } from '../../../constants';
import '../../../../src/assets/styles/hrmw-mcd.scss';
import BlurModal from '../../../../src/components/common/blur-modal';
import Button from '@dbk/ui-buttons';
import message from '@dbk/ui-forms/src/message/message';

class UserBPList extends Component {

  constructor(props) {
    super(props);
    this.props.hrmw.getBpData();
    this.state=({
			showRedirectModal: false,
			dataLostClicked: true,
			signHrmwAlert: false,
			multipleAccountHolderAlert: false
		});
  }

	componentDidMount = () => {
		this.props.hrmw.setIsUserBpListPage(true);
	}

	componentWillUnmount = () => {
		this.props.hrmw.setIsUserBpListPage(false);
	}

  redirectToInitialBpLanding = () => {
    this.props.setDeletedRow(false);
    this.props.setAddedRow(false);
    this.props.hrmw.resetFormStatus();
    this.setState({showRedirectModal: false});
    this.setState({dataLostClicked: false});
		this.props.changePage(ROUTES.PROFILE.USER_BP_LIST_ROUTE);
	}
  /* WMCE-27158  Removed filterButton style of buttons */
	// redirect modal content
	redirectModalContent = () => {
		const { i18n: { messages } } = this.props;
		return (
			<div>
				<div className="row small-12 medium-12 large-12 headerMargin">
					{messages['app.manageContactDetails.amendContact.warningMessage']}
				</div>
				<div className="row columns small-12 medium-12 large-12">
					<div className="columns large-2 medium-2 small-12 rightAligned">
						<Button fullWidth  size='normal' onClick={this.redirectToInitialBpLanding}>
							{messages['app.common.alert.yes']}
						</Button>
					</div>
					<div className="columns large-2 medium-2 small-12 rightAligned">
						<Button fullWidth tertiary  size='normal' onClick={this.hideRedirecteModal} >
							{messages['app.common.alert.no']}
						</Button>
					</div>
				</div>
			</div>
		)
	}

	// hide hideMultipleAccountHolderAlert
	hideMultipleAccountHolderAlert = () => {
		this.setState({multipleAccountHolderAlert: false, signHrmwAlert: false})
	}

	//Multiple account hoder modal
	multipleAccountHolderAlert = () => {
		const { i18n: { messages }} = this.props;
		return(
			<div className="headerMargin">
				<div className="row">
					<div className="columns small-1 medium-1 large-1">
						<NotificationWarning color='#b92635' className="error-icon" width={25} height={25} />
					</div>
					<div className="columns small-11 medium-11 large-11">
						<div className="row">
							{messages['app.manageContactDetails.missingDocument']}
						</div>
						<br />
						<div className="row">
							{this.state.signHrmwAlert ? messages['app.manageContactDetails.acceptHrmwrAlert'] : messages['app.manageContactDetails.multipleAccountHolderAlert'] }
						</div>
					</div>
					<br /><br />
					<div className="row">
						<div className="centerAligned">
							<Button size='normal' className="mt-20" onClick={this.hideMultipleAccountHolderAlert} >
								{messages['app.rmcallback.okMsg']}
							</Button>
						</div>
					</div>
				</div>
			</div>
		)
	}

	// Hide redirect modal
	hideRedirecteModal = () => {
		this.setState({showRedirectModal: false});
		this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
	}

 componentWillReceiveProps(prevProps, nextProps ){
  if((this.props.hrmw.isRowDeleted && this.state.dataLostClicked) || (this.props.hrmw.isRowAdded && this.state.dataLostClicked)){
    this.setState({showRedirectModal: true});
  }else{
    this.props.hrmw.resetFormStatus();
	this.props.paperless.setAcceptAndProceed(false);
    this.setState({showRedirectModal: false});
  }
 }

  bpSelected = async (row) => {
	await this.props.hrmw.setBpId(row.bpId);
	if(!row.singleAH) {
		this.setState({multipleAccountHolderAlert: true});
	} else {
		if(row.role.roleId == MANAGE_CONTACT_DETAILS_CONSTANTS.MANAGE_CONTACT_DETAILS_ACCOUNT_HOLDER) {
		if(!row.signedByAH) {
			this.props.changePage(ROUTES.PROFILE.USER_HRMW_FORM_ROUTE);
		} else {
			this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
		}
		} else {
			if(!row.signedByAH) {
				this.setState({signHrmwAlert: true});
			} else {
				this.props.changePage(ROUTES.PROFILE.MANAGE_CONTACT_DETAILS_ROUTE);
			}
		}
	}
}

  render() {
    const { i18n: { messages }, auth: {settingsDisabled}, hrmw: { bpRoleData, showSpinner } } = this.props;

    if( this.state.showRedirectModal ) {
			return ( 
				<BlurModal
				visible={true}
				onDone={this.hideRedirecteModal}
				title={messages['app.manageContactDetails.amendContact.warning']}
				size="large"
				>
				{this.redirectModalContent()}
				</BlurModal>
			);
		}

    if(showSpinner) {
      return <LoadingCircle />
    }

    return (
      <div className="small-12 medium-12 large-12 large-centered">
        <h1>{messages['app.common.pageTitle.manageContactDetails']}</h1>
          <div className="columns small-12 medium-12 large-12" style={{backgroundColor: "#12223C",padding:"5rem",marginBottom:"5rem"}}>
            <Text>{messages['app.hrmw.bpselectioninstruction']}</Text>
            <div className="column small-12 medium-12 large-12" style={{padding: '10px',paddingTop:"5rem"}}>
              <div className="columns large-5 medium-5 small-12">
                <Label className="column">{messages['app.hrmw.account']}</Label>
              </div>
              <div className="columns large-5 medium-5 small-12">
              <Label>{messages['app.hrmw.role']}</Label>
              </div>
            </div>
            {Array.isArray(bpRoleData) ? 
              <NavigationList fullWidth className="row small-12 medium-12 large-12">
                {bpRoleData.map((item, index) => (
                  <NavigationListItem className="column small-12 medium-12 large-12" hasArrow={false} onClick={() => !settingsDisabled ? this.bpSelected(item) : null} >
                    <div className="column small-12 medium-12 large-12" style={{padding: '10px'}}>
                      <div className="columns large-5 medium-5 small-12">
                        <span>{item.bpId}</span>
                      </div>
                      <div className="columns large-5 medium-5 small-12">
                        <span>{item.role.roleDescription}</span>
                      </div>
                    </div>
                  </NavigationListItem>
              ))}
              </NavigationList>
             : <div className="columns small-12 medium-12 large-12 noData">
              {messages['app.manageContactDetails.noData']}
           </div>}
          </div>

		  <BlurModal
			visible={this.state.multipleAccountHolderAlert || this.state.signHrmwAlert}
			onDone={this.hideMultipleAccountHolderAlert}
			title={messages['app.auth.logout.header']}
			size="large"
		>
			{this.multipleAccountHolderAlert()}
		</BlurModal>

      </div>
    );
  }
}

export default createContainer({
  $queries: {
    auth: {
      userId: true,
	  settingsDisabled: true
    },
    i18n: {
      messages: true,
    },
    hrmw: {
      setBpId: {$call: 'setBpId'},
      getBpData: {$call: 'getBpData'},
      saveFilters: { $call: 'saveFilters'},
      resetFormStatus: {$call: 'resetFormStatus'},
      bpRoleData: true,
      showSpinner: true,
      isRowDeleted: true,
      isRowAdded: true,
			setIsUserBpListPage: { $set: 'isUserBpListPage'},
    },
	paperless: {
		setAcceptAndProceed: { $set: 'acceptAndProceed'}
	},
    setDeletedRow: { $set: 'hrmw.isRowDeleted' },
    setAddedRow: { $set: 'hrmw.isRowAdded'}
  },
}) (UserBPList);